import { isBrowser } from "./common-utils";

export const isMobile =
  isBrowser() &&
  (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    : window.outerWidth !== 0 && window.outerWidth <= 1024);

export const isAndriod = isBrowser() && /Android/i.test(navigator.userAgent);
export const isIOS =
  isBrowser() && /iPhone|iPad|iPod/i.test(navigator.userAgent);
export const isMac =
  isBrowser() &&
  /mac/i.test(navigator.userAgent) &&
  !/iPhone|iPad|iPod/i.test(navigator.userAgent);
export const isSafari =
  isBrowser() && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
